<template>
    <div>
        <label :for="id" class="flex items-center space-x-2 cursor-pointer">
            <input
                type="radio"
                :id="id"
                :checked="isChecked"
                @click="onChecked"
                class="form-radio h-5 w-5 text-blue-600"
            />
            <span class="text-black dark:text-white">{{ label }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        isChecked: { type: Boolean, default: true },
        id: { type: String, default: "id", required: true },
        label: { type: String, default: "label", required: true }
    },
    emits: ["clickRadio"],
    methods: {
        onChecked() {
            this.$emit("clickRadio");
        }
    }
};
</script>
